import React, { ChangeEvent, useState } from 'react'

import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import type { TSavedDashboardFilterDto } from '@homepal/api-contract'
import { useTranslation } from 'language/translator'

interface SaveUserFilterDialogProps {
  onClose: () => void
  onSave: (value: string) => void
  open: boolean
  savedDashboardFilters: TSavedDashboardFilterDto[]
}

const SaveUserFilterDialog = (props: SaveUserFilterDialogProps) => {
  const { onClose, onSave, open, savedDashboardFilters } = props
  const { t } = useTranslation()

  const [title, setTitle] = useState<string>('')
  const [error, setError] = useState<boolean>(false)

  const handleOnClose = () => {
    setTitle('')
    setError(false)
    onClose()
  }

  return (
    <SimpleDialog
      title={t('filters', 'save_filter')}
      open={open}
      onClose={handleOnClose}
      actions={
        <>
          <Button variant="text" onClick={handleOnClose}>
            {t('global', 'cancel')}
          </Button>
          <Button
            disabled={!title || error}
            onClick={() => {
              const exists = savedDashboardFilters.find(
                (item) => item.title === title
              )

              if (exists) {
                setError(true)
              } else {
                onSave(title)
                handleOnClose()
              }
            }}
            variant="contained"
          >
            {t('global', 'save')}
          </Button>
        </>
      }
    >
      <TextField
        fullWidth
        error={error}
        helperText={error ? t('filters', 'duplicate_filter_name_error') : null}
        label={t('global', 'name')}
        onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
          setTitle(event.target.value)

          if (error) {
            setError(false)
          }
        }}
        value={title}
      />
    </SimpleDialog>
  )
}

export default SaveUserFilterDialog
